/* ROOK · site V2 « Le top set », 08/10/2026.
   Un seul état : le pré du client. Toutes les données concurrentes du site se calent dessus.
   Sources des chiffres : #rok-cmp-data (comparateur, relevés datés) ; produit et panier : #rok-v2-data (Shopify).
   Plan : commerce/site-plan-d-2026-10-08.md. */
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const dataEl = $('#rok-v2-data'), cmpEl = $('#rok-cmp-data');
  if (!dataEl || !cmpEl || window.ROKV2) return;
  const V = JSON.parse(dataEl.textContent), CMP = JSON.parse(cmpEl.textContent), T = V.t;
  const FR = (document.documentElement.lang || 'fr').toLowerCase().startsWith('fr');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const body = document.body;

  /* ---------- Données concurrentes (même méthode que le comparateur) ---------- */
  const RIV = CMP.rivals.map(p => ({...p, doses: {...p.doses}}));
  RIV.forEach(p => {
    if (p.malate) p.doses.citrulline = p.malate.pure ?? p.malate.declared * 2 / 3;
    p.nd = Object.keys(p.doses).filter(k => p.doses[k] == null); p.nd.forEach(k => { p.doses[k] = 0; });
    /* 11/10 : citrulline ou bêta-alanine sans quantité publiée (ex. Nutrimuscle) : aucun total, ratio ni prix au gramme affiché */
    p.hidden = p.nd.includes('citrulline') || p.nd.includes('beta');
    if (p.price == null && p.local && CMP.fx?.[p.local.cur]) { p.price = p.local.amount / CMP.fx[p.local.cur]; p.converted = true; }
  });
  const byId = id => RIV.find(r => r.id === id);
  const ROKD = CMP.rokDoses;
  const ACT = ['citrulline', 'beta', 'taurine', 'tyrosine', 'caffeine'];
  /* Total d'actifs par scoop ; caféine comptée jusqu'à 200 mg, comme le comparateur */
  const grams = d => d.citrulline + d.beta + d.taurine + d.tyrosine + Math.min(d.caffeine, 200) / 1000;
  const SELECT = V.select || ['origin', 'myprotein', 'c4', 'ghost', 'abe', 'total-war', 'kairyn'];
  const DEFAULT = byId(V.defaultRival) ? V.defaultRival : 'origin';

  /* ---------- Formats ---------- */
  const NB = ' ';
  const num = (v, d = 1) => { const t = String(Math.round(v * 10 ** d) / 10 ** d); return FR ? t.replace('.', ',') : t; };
  const dose = (v, act) => act === 'caffeine' ? Math.round(v) + NB + 'mg' : num(v, v > 0 && v < 1 ? 2 : 1) + NB + 'g';
  const money = new Intl.NumberFormat(FR ? 'fr-FR' : 'en-IE', {style: 'currency', currency: V.currency || 'EUR'});
  const eur = v => money.format(v);
  const cents = c => eur(c / 100);
  const fill = (s, o) => s.replace(/\{(\w+)\}/g, (m, k) => o[k] ?? '');
  const gOf = p => p.hidden ? 0 : grams(p.doses);
  const esc = v => String(v).replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
  const DATA_EN = [[/étiquette publiée par le revendeur/g, 'label published by the reseller'], [/étiquette lue le/g, 'label read on'], [/étiquette lue/g, 'label read'],
    [/vendu en dollars/g, 'sold in US dollars'], [/vendu en livres \(Royaume-Uni\)/g, 'sold in pounds (UK)'], [/vendu en livres/g, 'sold in pounds'],
    [/relevé du/g, 'checked on'], [/prix à revérifier/g, 'price to recheck'], [/page illisible le/g, 'page unreadable on'], [/\(revendeur\)/g, '(reseller)'],
    [/prix barré ([\d,]+)[\s ]?€ \(([\d,]+)[\s ]?€ en promo le ([\d/]+)\)/g, (m, a, b, d) => `list price €${a.replace(',', '.')} (€${b.replace(',', '.')} on offer on ${d})`],
    [/Boutique (\w+) UE/g, '$1 EU store'], [/Version UE/g, 'EU version'], [/tyrosine en N-acétyl-L-tyrosine/g, 'tyrosine as N-acetyl-L-tyrosine'], [/tyrosine en N-acétyl/g, 'tyrosine as N-acetyl'],
    [/malate de dicaféine/g, 'dicaffeine malate'], [/caféine ≈/g, 'caffeine ≈'], [/caféine/g, 'caffeine'], [/citrate et malate/g, 'citrate and malate'], [/sachet de/g, 'sachet of'], [/tableau/g, 'table'],
    [/fiche du ([\d/]+) et page du ([\d/]+)/g, 'product sheet of $1 and page of $2'], [/ dans /g, ' in '], [/ g de /g, ' g of '], [/colonne de l’étiquette UE/g, 'EU label column'],
    [/le fabricant met en avant (\d) scoops/g, 'the brand pushes $1 scoops'], [/(\d) scoops possibles/g, '$1 scoops possible'], [/\bdose\b/g, 'serving'], [/\bsachet\b/g, 'sachet'], [/(\d),(\d)/g, '$1.$2']];
  const dataTxt = v => FR ? v : DATA_EN.reduce((t, [re, to]) => t.replace(re, to), String(v));

  /* ---------- Mémoire du navigateur ---------- */
  const store = {get: k => { try { return localStorage.getItem(k); } catch { return null; } }, set: (k, v) => { try { localStorage.setItem(k, v); } catch {} }};
  const K = {rival: 'rok-cmp-rival', asked: 'rok-v2-asked', nopre: 'rok-v2-nopre', pop: 'rok-v2-pop', sub: 'rok-v2-sub'};

  /* ---------- Mode Noir / Blanc (choix du visiteur, mémorisé ; noir par défaut) ---------- */
  const rootEl = document.documentElement;
  const isLight = () => rootEl.classList.contains('rok-v3');
  const modeBtns = $$('[data-v2-mode]'), hint = $('[data-v2-mode-hint]');
  const syncMode = () => { modeBtns.forEach(b => b.setAttribute('aria-checked', String(isLight()))); const m = $('meta[name=theme-color]'); if (m) m.content = isLight() ? '#ffffff' : '#0b0b0b'; };
  const hideHint = () => { if (!hint) return; hint.classList.remove('is-on'); setTimeout(() => { hint.hidden = true; }, 450); };
  function showHint() {
    if (!hint || store.get('rok-mode-seen')) return;
    store.set('rok-mode-seen', '1');
    hint.hidden = false; requestAnimationFrame(() => hint.classList.add('is-on'));
    setTimeout(hideHint, 6500);
  }
  syncMode();
  modeBtns.forEach(b => b.addEventListener('click', () => {
    const to = !isLight();
    const apply = () => { rootEl.classList.toggle('rok-v3', to); store.set('rok-mode', to ? 'light' : 'dark'); syncMode(); };
    store.set('rok-mode-seen', '1'); hideHint();
    if (document.startViewTransition && !reduce) {
      const r = b.getBoundingClientRect();
      rootEl.style.setProperty('--vt-x', (r.left + r.width / 2) + 'px'); rootEl.style.setProperty('--vt-y', (r.top + r.height / 2) + 'px');
      document.startViewTransition(apply);
    } else apply();
  }));

  /* ---------- Le pré du client ---------- */
  const qs = new URLSearchParams(location.search);
  const fromAd = [qs.get('c'), location.hash.replace(/^#vs-/, ''), qs.get('vs')].find(byId) || null;
  const fromPage = byId(body.dataset.vs) ? body.dataset.vs : null;
  if (fromAd) { store.set(K.rival, fromAd); store.set(K.asked, '1'); }
  const saved = byId(store.get(K.rival)) ? store.get(K.rival) : null;
  let cur = byId(fromPage || fromAd || saved || DEFAULT);
  let chosen = !!(fromPage || fromAd || saved);
  const shown = () => chosen || !!store.get(K.asked);
  const renders = [];
  const on = f => { renders.push(f); f(cur); };
  const renderAll = () => renders.forEach(f => f(cur));
  function setRival(id, {quiet = false, from = null} = {}) {
    const p = byId(id); if (!p || (fromPage && id !== fromPage)) return;
    cur = p; chosen = true; store.set(K.rival, id); store.set(K.asked, '1'); store.set(K.nopre, '');
    renderAll();
    document.dispatchEvent(new CustomEvent('rok:v2rival', {detail: {id}}));
    if (!quiet) toast(fill(T.toastSet, {name: esc(p.name)}), p.img, p.id);
  }
  const rivalDose = act => cur.nd?.includes(act) ? 'ND' : dose(cur.doses[act] || 0, act);
  window.ROKV2 = {get rival() { return cur; }, get shown() { return shown(); }, rivalDose, setRival, byId, grams};

  /* Le comparateur change de pré : tout le site suit */
  document.addEventListener('rok:compare', e => {
    const d = e.detail || {};
    if (d.name === 'switch' && d.rival && d.rival !== cur.id) setRival(d.rival, {quiet: true});
  });

  /* ---------- Liaisons génériques ---------- */
  on(p => {
    $$('[data-rv]').forEach(el => {
      const k = el.dataset.rv;
      el.textContent = k === 'brand' ? p.brand : k === 'full' ? `${p.brand} ${p.name}` : p.name;
    });
    $$('[data-rv-img]').forEach(img => { img.src = p.img; img.alt = `${p.brand} ${p.name}`; });
    $$('[data-rv-act]').forEach(el => { el.textContent = fill(T.yourDose, {brand: p.brand, dose: rivalDose(el.dataset.rvAct)}); });
    $$('[data-rc-open]').forEach(b => { if (!b.hasAttribute('data-rc-fixed')) b.dataset.rcRival = p.id; });
    $$('.v2-vs').forEach(b => {
      b.classList.toggle('has-rival', shown());
      const img = $('img', b), nm = $('.nm', b);
      if (img) { img.src = p.img; img.alt = ''; }
      // Barre du bas (téléphone) : la marque, courte et lisible ; le nom du produit (« THE Pre-Workout ») y était coupé
      if (nm) nm.textContent = shown() ? (b.closest('.v2-bbar') ? p.brand : p.name) : T.yourPre;
    });
  });

  /* ---------- Message court ---------- */
  const toastEl = $('[data-v2-toast]');
  let toastT = 0;
  /* rival : ajoute « Comparer en détail », qui ouvre le comparateur sur ce pré */
  function toast(html, img, rival) {
    if (!toastEl) return;
    toastEl.innerHTML = (img ? `<img src="${esc(img)}" alt="">` : '') + `<span class="v2-toast__t">${html}</span>`
      + (rival ? `<button type="button" class="v2-toast__go" data-rc-open data-rc-fixed data-rc-rival="${esc(rival)}" data-rc-source="toast">${esc(T.toastCmp || '')}</button>` : '');
    toastEl.classList.remove('is-on'); void toastEl.offsetWidth;
    toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('is-on'), 4200);
  }

  /* ---------- Apparitions et compteurs ---------- */
  function countUp(el) {
    const to = parseFloat(el.dataset.count), d = +(el.dataset.d || 0);
    if (reduce || !isFinite(to)) { el.textContent = num(to, d); return; }
    const t0 = performance.now(), dur = 1100;
    const step = t => { const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3); el.textContent = num(to * e, k < 1 ? d : d); if (k < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  }
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(en => {
    if (!en.isIntersecting) return;
    const el = en.target; el.classList.add('is-in'); io.unobserve(el);
    $$('[data-count]', el).forEach(countUp);
    if (el.matches('[data-count]')) countUp(el);
    el.dispatchEvent(new CustomEvent('v2:in'));
  }), {threshold: .14, rootMargin: '0px 0px -6% 0px'}) : null;
  $$('[data-in], [data-watch]').forEach(el => { if (io) { $$('[data-count]', el).forEach(c => { c.textContent = num(0, +(c.dataset.d || 0)); }); io.observe(el); } else el.classList.add('is-in'); });
  body.classList.add('v2-ready');

  /* ---------- Header : solide au défilement, caché en descendant ---------- */
  const header = $('[data-v2-header]');
  const hero = $('.rok-hh, .v2-pagehero, .v2-vshero');
  let lastY = scrollY, ticking = false;
  function onScroll() {
    const y = scrollY;
    body.classList.toggle('is-scrolled', y > 30);
    if (header) {
      header.classList.toggle('is-solid', y > 30);
      const menuOpen = $('.v2-menu.is-open');
      header.classList.toggle('is-hidden', !menuOpen && y > 160 && y > lastY + 2);
      if (y < lastY - 2 || y < 160) header.classList.remove('is-hidden');
    }
    lastY = y; ticking = false;
    bbarCheck();
  }
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, {passive: true});

  /* Menu mobile */
  const menu = $('[data-v2-menu]');
  const setMenu = open => {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    $$('[data-v2-burger]').forEach(b => b.setAttribute('aria-expanded', open));
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) $('a,button', menu)?.focus({preventScroll: true});
  };
  $$('[data-v2-burger]').forEach(b => b.addEventListener('click', () => setMenu(!menu.classList.contains('is-open'))));
  $$('[data-v2-menu-close], [data-v2-menu] a').forEach(b => b.addEventListener('click', () => setMenu(false)));
  $$('[data-v2-menu] [data-rc-open], [data-v2-menu] [data-v2-pick]').forEach(b => b.addEventListener('click', () => setMenu(false)));

  /* Langue : envoi du formulaire de localisation Shopify au changement */
  /* Changement de langue : même page, même pré (?c=) et même ancre (#vs-) ; audit SEO du 11/10 */
  $$('[data-v2-lang]').forEach(s => s.addEventListener('change', () => { const u = new URL(location.href); u.pathname = u.pathname.replace(/^\/en(?=\/|$)/, '') || '/'; if (s.value === 'en') u.pathname = '/en' + (u.pathname === '/' ? '' : u.pathname); location.assign(u.pathname + u.search + u.hash); }));

  /* ---------- Barre du bas (mobile) ---------- */
  const bbar = $('[data-v2-bbar]');
  const buyZones = $$('#buy-rok, [data-v2-offer]');
  let buyVisible = false;
  if (buyZones.length && 'IntersectionObserver' in window) {
    const seen = new Set();
    new IntersectionObserver(es => { es.forEach(e => e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)); buyVisible = seen.size > 0; bbarCheck(); }, {threshold: .25}).observe(buyZones[0]);
    buyZones.slice(1).forEach(z => new IntersectionObserver(es => { es.forEach(e => e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)); buyVisible = seen.size > 0; bbarCheck(); }, {threshold: .25}).observe(z));
  }
  function bbarCheck() {
    if (!bbar) return;
    const past = hero ? hero.getBoundingClientRect().bottom < 80 : scrollY > 240;
    const on = past && !buyVisible && !$('.v2-pick.is-open') && !$('.v2-cart.is-open');
    bbar.classList.toggle('is-on', on);
    body.classList.toggle('has-bbar', on);
  }

  /* ---------- Sélecteur de pré ---------- */
  const pick = $('[data-v2-pick-panel]');
  let pickOpen = false, pickClosedAt = 0;
  function buildPick() {
    if (!pick || pick.dataset.built) return;
    pick.dataset.built = '1';
    /* Tous les pré du comparateur, en couleur ; les 15 plus connus d'abord (même liste que la frise) */
    const first = (CMP.pick || CMP.wall || SELECT).filter(byId);
    const order = [...first, ...RIV.map(p => p.id).filter(id => !first.includes(id))];
    const count = $('[data-v2-pick-count]', pick); if (count) count.textContent = RIV.length;
    const grid = $('[data-v2-pick-grid]', pick), input = $('[data-v2-pick-q]', pick), empty = $('[data-v2-pick-empty]', pick);
    grid.innerHTML = order.map(id => {
      const p = byId(id);
      return `<li data-q="${esc(`${p.brand} ${p.name}`.toLowerCase())}"><button type="button" class="v2-pot" data-v2-choose="${p.id}" title="${esc(`${p.brand} ${p.name}`)}"><span class="v2-pot__img"><img src="${esc(p.img)}" alt="" loading="lazy"></span><b>${esc(p.brand)}</b><small>${esc(p.name)}</small><em>${p.hidden ? 'ND' : num(grams(p.doses), grams(p.doses) < 10 ? 2 : 1) + NB + 'g'}<i> ${esc(T.actShort)}</i></em></button></li>`;
    }).join('');
    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase(); let n = 0;
      $$('li', grid).forEach(li => { const hit = !q || li.dataset.q.includes(q); li.hidden = !hit; n += hit; });
      empty.hidden = n > 0; empty.textContent = T.notListed;
    });
    $('[data-v2-pick-none]', pick).addEventListener('click', () => {
      store.set(K.asked, '1'); store.set(K.nopre, '1'); closePick(); renderAll();
      toast(T.toastNone);
    });
    pick.addEventListener('click', e => {
      const b = e.target.closest('[data-v2-choose]'); if (!b) return;
      const id = b.dataset.v2Choose;
      setRival(id, {quiet: true});
      verdict(byId(id));
    });
    /* Verdict : boutons (délégués, le contenu est réécrit à chaque pré) */
    const vd = $('[data-v2-pick-verdict]', pick);
    vd?.addEventListener('click', e => {
      if (e.target.closest('[data-vd-back]')) { resetVerdict(); $('[data-v2-pick-q]', pick)?.focus({preventScroll: true}); }
      if (e.target.closest('[data-vd-go]')) { closePick(); const s = $('#comparateur'); if (s) s.scrollIntoView({behavior: reduce ? 'auto' : 'smooth'}); else location.href = (window.Shopify?.routes?.root || '/') + '#comparateur'; } // 12/10 (Enzo) : vers « What's in your pre? »
    });
    $$('[data-v2-pick-close]', pick).forEach(b => b.addEventListener('click', () => { store.set(K.asked, '1'); closePick(); renderAll(); }));
    /* Glisser vers le bas pour fermer (mobile) */
    const grab = $('.v2-pick__grab', pick); let y0 = null;
    const move = e => { if (y0 == null) return; const dy = Math.max(0, e.clientY - y0); pick.style.setProperty('--drag', dy + 'px'); };
    const end = e => { if (y0 == null) return; const dy = e.clientY - y0; y0 = null; pick.classList.remove('is-drag'); pick.style.removeProperty('--drag'); if (dy > 80) { store.set(K.asked, '1'); closePick(); renderAll(); } };
    [grab, $('.v2-pick__head', pick)].forEach(h => h?.addEventListener('pointerdown', e => { if (e.target.closest('button')) return; y0 = e.clientY; pick.classList.add('is-drag'); h.setPointerCapture?.(e.pointerId); }));
    pick.addEventListener('pointermove', move); pick.addEventListener('pointerup', end); pick.addEventListener('pointercancel', end);
  }

  /* ---------- Formulaires email : messages ROOK à la place des bulles du navigateur (11/10/2026, Enzo) ----------
     La validation native reste active (elle bloque l'envoi, y compris le parcours anti-robot de Shopify) ;
     on supprime seulement sa bulle et on affiche notre message sous le champ. */
  const MSG = FR
    ? {empty: 'Entre ton email.', bad: 'Email incomplet. Exemple : nom@mail.com', consent: 'Coche la case pour recevoir les emails ROOK.'}
    : {empty: 'Enter your email.', bad: 'Incomplete email. Example: name@mail.com', consent: 'Tick the box to get ROOK emails.'};
  $$('form').filter(f => f.querySelector('input[name="form_type"][value="customer"]')).forEach(f => {
    const mail = f.querySelector('input[type="email"]');
    const check = () => { if (mail) mail.setCustomValidity(mail.value && !/^\S+@\S+\.\S{2,}$/.test(mail.value.trim()) ? MSG.bad : ''); };
    let shown = false;
    const say = (el, text) => {
      let m = f.querySelector('.rok-field-msg');
      if (!m) { m = document.createElement('p'); m.className = 'rok-field-msg'; m.setAttribute('role', 'alert'); f.appendChild(m); }
      m.textContent = text; m.hidden = false;
      el.classList.remove('is-bad'); void el.offsetWidth; el.classList.add('is-bad');
    };
    f.addEventListener('invalid', e => {
      e.preventDefault();
      if (shown) return; shown = true; setTimeout(() => { shown = false; }, 50);
      const el = e.target;
      say(el, el.type === 'checkbox' ? MSG.consent : !el.value.trim() ? MSG.empty : MSG.bad);
      el.focus({preventScroll: true});
    }, true);
    f.addEventListener('submit', check, true);
    f.addEventListener('input', e => { check(); e.target.classList?.remove('is-bad'); const m = f.querySelector('.rok-field-msg'); if (m) m.hidden = true; });
    f.addEventListener('change', e => { e.target.classList?.remove('is-bad'); });
  });

  /* ---------- Verdict du pré choisi (12/10/2026, Enzo, 5e version : « beaucoup plus simple, plus lisible », aucune animation) ----------
     Deux barres de même piste : le pré du visiteur (pot en couleur, barre grise) contre ROOK (barre argent pleine, chiffre plus grand),
     puis « Il te manque N g d'actifs par scoop. ». Affichage direct. Doses cachées : « ? » et phrase dédiée. */
  function resetVerdict() {
    const v = pick && $('[data-v2-pick-verdict]', pick); if (!v) return;
    v.hidden = true; pick.classList.remove('is-verdict');
  }
  function verdict(p) {
    const v = $('[data-v2-pick-verdict]', pick); if (!v || !p) { closePick(); return; }
    const VT = JSON.parse($('[data-v2-pick-verdict-t]', v).textContent);
    const gR = grams(p.doses), gK = grams(ROKD), hid = !!p.hidden;
    const g = n => num(n, n < 10 ? 2 : 1) + NB + 'g';
    const w = hid ? 0 : Math.max(4, Math.min(100, gR / gK * 100)), name = `${p.brand} ${p.name}`;
    const head = hid ? `${esc(VT.hh)} <em>${esc(VT.hhEm)}</em>` : `${esc(VT.h)} <em>LIGHT.</em>`;
    const line = hid ? esc(VT.hidLine) : esc(VT.miss).replace('{g}', `<em>${g(Math.max(0, gK - gR))}</em>`);
    const row = (img, alt, nm, pct, val, rook) => `<div class="vd-row${rook ? ' is-rook' : ''}"><span class="vd-pot"><img src="${esc(img)}" alt="${esc(alt)}"></span><div class="vd-rbody"><p class="vd-nm">${esc(nm)}</p><span class="vd-bar"><i style="width:${pct}%"></i></span></div><b>${val}</b></div>`;
    $('[data-vd-body]', v).innerHTML = `<h2 class="vd-h">${head}</h2>
      <div class="vd-bars">${row(p.img, name, p.name, w, hid ? '?' : g(gR))}${row(VT.rookImg, 'ROOK Pre-Workout', 'ROOK', 100, g(gK), true)}</div>
      <p class="vd-line">${line}</p>`;
    $('[data-vd-go]', v).textContent = hid ? VT.hgo : VT.go;
    v.hidden = false; pick.classList.add('is-verdict');
  }
  function openPick() {
    if (!pick) return;
    buildPick(); closePop(); resetVerdict();
    $$('[data-v2-choose]', pick).forEach(b => b.classList.toggle('is-on', chosen && b.dataset.v2Choose === cur.id));
    pick.classList.add('is-open'); pick.setAttribute('aria-hidden', 'false'); pickOpen = true; bbarCheck();
    $('[data-v2-pick-veil]')?.classList.add('is-on'); document.documentElement.style.overflow = 'hidden';
    const fine = matchMedia('(hover:hover) and (pointer:fine)').matches;
    setTimeout(() => (fine ? $('[data-v2-pick-q]', pick) : $('.v2-pot', pick))?.focus({preventScroll: true}), 350);
  }
  function closePick() {
    if (!pick || !pickOpen) return;
    pick.classList.remove('is-open'); pick.setAttribute('aria-hidden', 'true'); pickOpen = false; pickClosedAt = Date.now(); bbarCheck();
    $('[data-v2-pick-veil]')?.classList.remove('is-on'); document.documentElement.style.overflow = '';
    setTimeout(showHint, 900);
  }
  document.addEventListener('click', e => { if (e.target.closest('[data-v2-pick]')) { e.preventDefault(); openPick(); } });
  $('[data-v2-pick-veil]')?.addEventListener('click', () => { store.set(K.asked, '1'); closePick(); renderAll(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { if (pickOpen) { store.set(K.asked, '1'); closePick(); renderAll(); } closeCart(); closePop(); setMenu(false); } });
  /* Ouverture automatique sur l'accueil, à chaque chargement tant que le visiteur n'a pas choisi de pré
     (ni répondu « Je n'en prends pas ») ; jamais depuis une pub ; vers 1,5 s ou au premier geste (Enzo, 08/10) */
  /* MODE TEST (11/10, demande d'Enzo) : le sélecteur revient à chaque chargement de l'accueil, même après un choix.
     Remettre à false avant publication. */
  const PICK_TEST = false;
  if (pick && body.dataset.autopick === 'true' && (PICK_TEST || (!fromAd && !saved && !store.get(K.nopre)))) {
    let done = false, waiting = false;
    /* 11/10 : sur une première visite, la bannière cookies de Shopify recouvrait le sélecteur ; il attend la réponse du visiteur */
    const bannerUp = () => { const b = document.getElementById('shopify-pc__banner'); return !!(b && b.getClientRects().length && getComputedStyle(b).visibility !== 'hidden' && getComputedStyle(b).display !== 'none'); };
    const waitBanner = () => {
      if (waiting) return; waiting = true;
      const ok = () => { if (bannerUp()) return; mo.disconnect(); waiting = false; setTimeout(go, 500); };
      const mo = new MutationObserver(ok); mo.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']});
      document.addEventListener('visitorConsentCollected', ok, {once: true});
    };
    const go = () => { if (done) return; if (bannerUp()) { waitBanner(); return; } done = true; ['wheel', 'touchmove', 'keydown'].forEach(t => removeEventListener(t, go)); if (!$('[data-rc-modal][open]') && !$('.v2-cart.is-open')) openPick(); };
    setTimeout(go, 1500);
    ['wheel', 'touchmove', 'keydown'].forEach(t => addEventListener(t, go, {passive: true, once: true}));
  }
  /* Le pot choisi rejoint la case VS visible (ouverture, barre du bas ou header) */
  function fly(fromImg, src) {
    if (reduce || !fromImg) return;
    const targets = $$('.rok-hh-slot, .v2-bbar .v2-vs img, .v2-hvs img').filter(t => { const r = t.getBoundingClientRect(); return r.width && r.bottom > 0 && r.top < innerHeight && getComputedStyle(t.closest('.v2-bbar, .v2-hvs, .rok-hh') || t).display !== 'none'; });
    const target = targets[0]; if (!target) return;
    const a = fromImg.getBoundingClientRect(), b = target.getBoundingClientRect();
    const im = document.createElement('img'); im.src = src; im.className = 'v2-fly';
    Object.assign(im.style, {left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px'});
    body.appendChild(im);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      im.style.transform = `translate(${b.left + b.width / 2 - (a.left + a.width / 2)}px, ${b.top + b.height / 2 - (a.top + a.height / 2)}px) scale(${Math.max(.2, b.height / a.height)})`;
      im.style.opacity = '0';
    }));
    setTimeout(() => im.remove(), 1300);
  }

  /* ---------- Ouverture de l'accueil ---------- */
  const hh = $('.rok-hh');
  if (hh) on(p => {
    hh.classList.toggle('has-rival', shown());
    const b = $('.rok-hh-btn--vs', hh); if (!b) return;
    b.classList.toggle('has-rival', shown());
    const img = $('.rok-hh-slot img', b); if (img) img.src = p.img;
    const l = $('.rok-hh-vsl', b); if (l) l.textContent = shown() ? fill(T.vsName, {name: p.name}) : T.compareYour;
  });

  /* ---------- Produit et panier Shopify ---------- */
  const P = V.product;
  /* Produit pas encore publié sur la boutique en ligne : variantes connues du produit réel (07/10) */
  const variants = P?.variants || V.fallback.ids.map((id, i) => ({id, price: V.fallback.prices[i], compare: V.fallback.compare[i], available: true}));
  const priceOf = i => variants[i]?.price ?? V.fallback.prices[i];
  const compareOf = i => variants[i]?.compare ?? V.fallback.compare[i];
  const ACT_PER_SCOOP = grams(ROKD);

  /* ---------- E3 : ROOK contre ton pré ---------- */
  $$('[data-v2-versus]').forEach(sec => {
    let live = false;
    const draw = p => {
      $$('[data-bar]', sec).forEach(row => {
        const a = row.dataset.bar, r = a === 'total' ? grams(ROKD) : ROKD[a], t = a === 'total' ? grams(p.doses) : (p.doses[a] || 0);
        const fmt = v => a === 'total' ? num(v, 1) + NB + 'g' : dose(v, a);
        const max = Math.max(r, t) || 1;
        $('[data-v="rok"]', row).textContent = fmt(r);
        $('[data-v="rival"]', row).textContent = (p.nd?.includes(a) || (a === 'total' && p.hidden)) ? 'ND' : t ? fmt(t) : (a === 'total' ? fmt(0) : '0');
        $('[data-f="rok"]', row).style.setProperty('--k', live ? r / max : 0);
        $('[data-f="rival"]', row).style.setProperty('--k', live ? t / max : 0);
        /* Couleurs du comparateur : argent pour le plus dosé, rouge pour le plus faible, gris au-delà du plafond caféine */
        const capped = a === 'caffeine' && t > 200, tie = Math.abs(r - t) < 1e-9;
        const rokWin = tie || capped || r > t, rivWin = tie || (!capped && t > r);
        const fr = $('[data-f="rok"]', row), ft = $('[data-f="rival"]', row);
        fr.className = 'v2-bar__fill ' + (rokWin ? 'is-win' : 'is-lose');
        ft.className = 'v2-bar__fill ' + (capped ? 'is-capped' : rivWin ? 'is-win' : 'is-lose');
        $('[data-v="rok"]', row).classList.toggle('is-lose', !rokWin);
        $('[data-v="rival"]', row).classList.toggle('is-lose', !capped && !rivWin);
        const note = $('[data-note]', row);
        if (note) note.textContent = a === 'citrulline' && p.malate ? fill(p.malate.pure != null ? T.malDecl : T.malNote, {d: num(p.malate.declared, 1), v: num(p.doses.citrulline, 1)})
          : a === 'caffeine' && capped ? T.cafCap : '';
        if (note) note.classList.toggle('is-cap', a === 'caffeine' && capped);
      });
      $$('[data-v2-meta]', sec).forEach(el => { el.textContent = `${p.converted ? '≈ ' : ''}${eur(p.price)} · ${p.servings} scoops`; });
      /* Ce que tu paies vraiment : prix du scoop, actifs par scoop, prix du gramme d'actif (prix catalogue, ROOK en Solo) */
      const rokScoop = priceOf(0) / 100 / 20, rokG = grams(ROKD), rvScoop = p.price / p.servings, rvG = gOf(p);
      const ap = p.converted ? '≈ ' : '';
      const setP = (k, a, b, cls) => { const row = $(`[data-p="${k}"]`, sec); if (!row) return; const ra = $('[data-p-rok]', row), rb = $('[data-p-rv]', row); ra.textContent = a; rb.textContent = b; rb.classList.toggle('is-lose', cls === 'lose'); ra.classList.toggle('is-lose', cls === 'rok-lose'); };
      setP('scoop', eur(rokScoop), ap + eur(rvScoop));
      setP('act', num(rokG, 1) + NB + 'g', p.hidden ? 'ND' : num(rvG, 1) + NB + 'g', rvG < rokG ? 'lose' : rvG > rokG ? 'rok-lose' : '');
      const gR = rokScoop / rokG, gT = rvG ? rvScoop / rvG : Infinity;
      setP('gram', eur(gR), rvG ? ap + eur(gT) : '–', gT > gR ? 'lose' : gT < gR ? 'rok-lose' : '');
      const vEl = $('[data-v2-verdict]', sec);
      if (vEl) {
        const r2 = v => Math.round(v * 100) / 100, x = rvG ? rokG / rvG : 0, d = Math.abs(r2(rokScoop) - r2(rvScoop)), pct = rvG ? Math.round(Math.abs(1 - gR / gT) * 100) : 0;
        let h = x > 1.05 ? fill(rokScoop >= rvScoop ? T.verdictMore : T.verdictLess, {d: eur(d), x: num(x, 1)}) : '';
        if (rvG && pct >= 1) h += ' ' + fill(gR < gT ? T.gramCheaper : T.gramDearer, {p: pct});
        vEl.innerHTML = h;
      }
      $$('[data-v2-src]', sec).forEach(el => { el.textContent = fill(T.source, {src: dataTxt(p.source), base: dataTxt(p.base)}); });
      const others = $('[data-v2-others]', sec);
      if (others) others.innerHTML = SELECT.filter(id => id !== p.id && byId(id) && !byId(id).hidden).slice(0, 4).map(id => {
        const q = byId(id);
        return `<button type="button" class="v2-other" data-rc-open data-rc-fixed data-rc-rival="${q.id}" data-rc-source="pdp-others"><img src="${esc(q.img)}" alt="" loading="lazy"><span><b>${esc(q.brand)} ${esc(q.name)}</b><small>${esc(fill(T.otherLine, {cit: dose(q.doses.citrulline, 'citrulline')}))}</small></span><span class="g">${num(grams(q.doses), 1)}${NB}g <small class="v2-mute">${esc(T.actShort)}</small></span></button>`;
      }).join('');
    };
    on(draw);
    sec.addEventListener('v2:in', () => { live = true; draw(cur); });
    if (!io) { live = true; draw(cur); }
  });

  /* ---------- E4 : sensations, image fixe sur ordinateur ---------- */
  $$('[data-v2-feel]').forEach(sec => {
    const imgs = $$('[data-v2-feel-img]', sec), cap = $('[data-v2-feel-cap]', sec), items = $$('.v2-sense', sec);
    if (!imgs.length || !('IntersectionObserver' in window)) return;
    const dots = $$('.v2-feel__prog i', sec);
    const set = i => { items.forEach((it, k) => it.classList.toggle('is-cur', k === i)); imgs.forEach((im, k) => im.classList.toggle('is-on', k === i)); dots.forEach((d, k) => d.classList.toggle('is-on', k <= i)); if (cap) cap.textContent = items[i]?.dataset.line || ''; };
    set(0);
    const o = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) set(items.indexOf(e.target)); }), {rootMargin: '-45% 0px -45% 0px'});
    items.forEach(it => o.observe(it));
  });

  /* Doses des sensations : barre ROOK (argent) contre barre du pré choisi (rouge si plus faible, gris au-delà du plafond caféine) */
  on(p => {
    $$('[data-v2-dose]').forEach(li => {
      const a = li.dataset.v2Dose, r = +li.dataset.rok, t = p.doses[a] || 0, max = Math.max(r, t) || 1;
      const capped = a === 'caffeine' && t > 200;
      $('.v2-dose__bar:not(.v2-dose__bar--rv) i', li).style.setProperty('--k', r / max);
      const f = $('[data-v2-dose-fill]', li);
      f.style.setProperty('--k', t / max);
      f.className = capped ? 'is-capped' : t >= r ? 'is-win' : 'is-lose';
      $('[data-v2-dose-v]', li).textContent = dose(t, a);
      li.classList.toggle('is-lose', !capped && t < r);
    });
    $$('[data-v2-capnote]').forEach(el => { el.hidden = !((p.doses.caffeine || 0) > 200); });
  });

  /* ---------- E5 : ton pré dans le piège du malate, en barres (échelle : 10 g de ROOK) ---------- */
  on(p => {
    $$('[data-v2-yours="malate"]').forEach(el => {
      const cit = p.doses.citrulline || 0, decl = p.malate ? p.malate.declared : cit;
      $('[data-m-l]', el).textContent = fill(T.mYours, {name: p.name});
      $('[data-m-s]', el).textContent = p.malate ? fill(T.mDecl, {d: num(decl, 1)}) : cit ? fill(T.mPure, {v: num(cit, 1)}) : T.mNone;
      $('[data-m-v]', el).innerHTML = (p.malate ? '≈' + NB : '') + num(cit, 1) + '<span class="rok-u">' + NB + 'g</span>';
      el.style.setProperty('--c', Math.min(cit, 10) / 10);
      el.style.setProperty('--m', Math.min(Math.max(decl - cit, 0), 10) / 10);
      el.classList.toggle('is-lose', cit < 10);
    });
  });

  /* Rituel « Twenty minutes out. » : la frise repart de zéro toutes les 5 s quand elle est visible */
  $$('.v2-rit').forEach(rit => {
    if (reduce) { rit.classList.add('is-play'); return; }
    let timer = 0;
    /* Chaque étape s'allume quand la barre (3,6 s, linéaire) atteint son point : délai calculé sur la position réelle */
    const DUR = 3.6, track = $('.v2-rit__track', rit);
    const sync = () => {
      const tr = track && track.offsetParent ? track.getBoundingClientRect() : null;
      $$('.v2-rit__steps li', rit).forEach((li, k) => {
        const d = $('.dot', li), r = d && d.getBoundingClientRect();
        li.style.setProperty('--dl', (tr && r ? Math.max(0, (r.left + r.width / 2 - tr.left) / tr.width * DUR - .1) : k * 1).toFixed(2) + 's');
      });
    };
    const play = () => { sync(); rit.classList.remove('is-play'); void rit.offsetWidth; rit.classList.add('is-play'); };
    const vis = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => {
      clearInterval(timer);
      if (e.isIntersecting) { play(); timer = setInterval(play, 5000); }
    }), {threshold: .35}) : null;
    vis ? vis.observe(rit) : play();
  });

  /* Choix Solo, Duo, Trio : prix, prix au scoop, au gramme, et prix au gramme du pré choisi */
  $$('[data-v2-packs]').forEach(form => {
    const root = form.closest('[data-v2-buybox]') || form;
    /* Fiche : abonnement (prix fixes data-sub-prices, livraison offerte) ou achat unique ; plans de vente Shopify lus dans data-plans */
    const planBox = $('.v2-plan', form);
    const subPrices = (planBox?.dataset.subPrices || '').split(',').map(Number).filter(Boolean);
    // Abonnement sur le Solo uniquement (Enzo, 08/10) : Duo et Trio passent en achat unique ; retour au Solo = abonnement,
    // sauf si le visiteur a choisi lui-même l'achat unique sur le Solo
    const subOpt = $('[data-v2-subopt]', form), subNote = $('[data-v2-subnote]', form);
    let onceByHand = false, lastPack = 0;
    form.addEventListener('change', e => { if (e.target.name === 'rok-plan') onceByHand = e.target.value === 'once'; }, true);
    let plans = []; try { plans = JSON.parse(planBox?.dataset.plans || '[]'); } catch {}
    const sync = () => {
      const i = Math.max(0, $$('input[name="rok-pack"]', form).findIndex(r => r.checked));
      if (planBox && i !== lastPack) {
        const r = $(`input[name="rok-plan"][value="${i === 0 && !onceByHand ? 'sub' : 'once'}"]`, form); if (r) r.checked = true;
        lastPack = i;
      }
      const sub = !!planBox && i === 0 && $('input[name="rok-plan"]:checked', form)?.value === 'sub';
      // style.display plutôt que hidden : .v2-plan__opt est en display:block dans la feuille de la fiche
      if (subOpt) subOpt.style.display = i > 0 ? 'none' : '';
      if (subNote) { subNote.hidden = i === 0; subNote.style.display = i === 0 ? 'none' : ''; }
      // Prix abonné fixé par pack (grille du 08/10) ; repli : prix de secours du thème
      const subOf = k => subPrices[k] || V.fallback.sub?.[k] || priceOf(k);
      const pots = i + 1, price = (sub ? subOf(i) : priceOf(i)) / 100, scoops = pots * 20;
      $$('[data-v2-total]', root).forEach(el => { el.textContent = eur(priceOf(i) / 100); });
      $$('[data-v2-subprice]', root).forEach(el => { el.textContent = eur(subOf(i) / 100); });
      $$('[data-v2-subwas]', root).forEach(el => { el.textContent = eur(priceOf(i) / 100); });
      $$('[data-v2-was]', root).forEach(el => { const c = compareOf(i); el.textContent = c && c > priceOf(i) ? cents(c) : ''; });
      // Carte Solo : prix abonné (44,90 € barré) quand l'abonnement est choisi ; Duo et Trio toujours en achat unique
      if (planBox) {
        const soloSub = $('input[name="rok-plan"]:checked', form)?.value === 'sub' || i > 0 && !onceByHand;
        $$('[data-v2-cardprice]', form).forEach((el, k) => {
          const s = k === 0 && soloSub, now = s ? subOf(0) : priceOf(k), was = s ? priceOf(0) : compareOf(k);
          el.innerHTML = `${esc(eur(now / 100))}${was && was > now ? ` <s>${esc(eur(was / 100))}</s>` : ''}`;
        });
      }
      $$('[data-v2-perscoop]', root).forEach(el => { el.textContent = eur(price / scoops); });
      // Fiche : la barre du bas affiche le prix du choix en cours (abonnement 37,90 € présélectionné), pas le prix d'appel
      if (root.id === 'buy-rok') $$('[data-v2-from]').forEach(el => { el.textContent = eur(price); });
      $$('[data-v2-pergram]', root).forEach(el => { el.textContent = eur(price / scoops / ACT_PER_SCOOP); });
      // Achat unique : port 4,90 € quel que soit le pack, offert sur la 1re commande avec l'email (grille du 08/10)
      $$('[data-v2-ship]', root).forEach(el => { el.textContent = T.shipSolo; });
      const v = variants[i], btn = $('[data-add-to-cart]', root);
      if (btn) {
        btn.dataset.variant = v?.id || '';
        // Plan d'abonnement : celui dont le nom contient la fréquence choisie, sinon le premier ; aucun plan = achat unique
        const vp = plans[i] || [], wk = $('[data-v2-every]', form)?.value;
        btn.dataset.plan = sub ? ((vp.find(x => wk && new RegExp(`\\b${wk}\\b`).test(x.name)) || vp[0])?.id || '') : '';
        const out = v && !v.available;
        btn.disabled = !!out;
        $('.lbl', btn).textContent = out ? T.soldOut : T.addToBag;
      }
      $$('[data-v2-soldout]', root).forEach(el => { el.hidden = !(v && !v.available); });
    };
    // Pack choisi depuis l'offre de l'accueil (?pack=2) : présélectionné dans le panneau de la fiche
    const want = +new URLSearchParams(location.search).get('pack');
    if (root.id === 'buy-rok' && want >= 1 && want <= 3) { const r = $$('input[name="rok-pack"]', form)[want - 1]; if (r) r.checked = true; }
    form.addEventListener('change', sync); sync();
    /* Choisir un pack ne fait pas défiler la page (le focus du bouton radio caché remontait au titre) */
    $$('.v2-pack', form).forEach(lab => lab.addEventListener('click', e => {
      const r = $('input', lab); if (!r) return;
      e.preventDefault();
      if (!r.checked) { r.checked = true; form.dispatchEvent(new Event('change', {bubbles: true})); }
      r.focus({preventScroll: true});
    }));
    on(p => {
      $$('[data-v2-rvgram]', root).forEach(el => {
        const g = gOf(p), per = p.price / p.servings / (g || 1);
        el.innerHTML = g ? fill(T.rvGram, {name: esc(p.name), v: (p.converted ? '≈ ' : '') + eur(per), rok: eur(priceOf(0) / 100 / 20 / ACT_PER_SCOOP)}) : '';
      });
      // Fiche : troisième colonne du prix, le gramme d'actif du pré-workout choisi (rouge s'il revient plus cher que ROOK en Solo)
      $$('[data-v2-rvstat]', root).forEach(box => {
        const g = gOf(p), per = p.price / p.servings / (g || 1);
        box.hidden = !g;
        if (!g) return;
        $('[data-v2-rvg]', box).textContent = (p.converted ? '≈ ' : '') + eur(per);
        box.classList.toggle('is-dear', per > priceOf(0) / 100 / 20 / ACT_PER_SCOOP);
      });
    });
  });
  /* Pack prix d'appel affiché dans la barre du bas */
  if (!$('#buy-rok')) $$('[data-v2-from]').forEach(el => { el.textContent = cents(priceOf(0)); });

  const cartEl = $('[data-v2-cart]');
  let cartState = null;
  const R = V.routes;
  const api = (url, data) => fetch(url, {method: data ? 'POST' : 'GET', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: data ? JSON.stringify(data) : undefined, credentials: 'same-origin'})
    .then(async r => { const j = await r.json().catch(() => ({})); if (!r.ok) throw j; return j; });
  /* Shaker ROOK offert (21/10/2026 soir, Enzo) : ajouté seul au sac, à 0 € par la réduction automatique Shopify, quand le sac
     contient un Duo ou un Trio en achat unique ou un Solo en abonnement ; retiré seul quand ce n'est plus le cas. Ligne repérée
     par la propriété privée _rook_gift (invisible au paiement) : un shaker acheté en plus reste une ligne payante, jamais retirée.
     Au plus deux corrections par lecture du sac, aucune relance en boucle ; en cas d'échec, le sac reste utilisable. */
  const GIFT = '_rook_gift', SHK = +(V.shaker?.id || 0);
  const isGift = it => SHK && it.variant_id === SHK && !!it.properties?.[GIFT];
  const isPack = (it, k) => variants[k] && it.variant_id === +variants[k].id;
  const giftWanted = c => c.items.some(it => !it.selling_plan_allocation && (isPack(it, 1) || isPack(it, 2))) || c.items.some(it => it.selling_plan_allocation && isPack(it, 0));
  let giftBusy = false;
  async function giftSync() {
    if (giftBusy || !SHK || !cartState) return false;
    giftBusy = true; let changed = false;
    try {
      for (let pass = 0; pass < 2; pass++) {
        const c = cartState, gifts = c.items.filter(isGift), want = giftWanted(c);
        let req = null;
        if (want && !gifts.length) req = [R.add + '.js', {items: [{id: SHK, quantity: 1, properties: {[GIFT]: '1'}}]}];
        else if (!want && gifts.length) req = [R.change + '.js', {id: gifts[0].key, quantity: 0}];
        else if (gifts.length > 1) req = [R.change + '.js', {id: gifts[1].key, quantity: 0}];
        else if (gifts[0]?.quantity > 1) req = [R.change + '.js', {id: gifts[0].key, quantity: 1}];
        if (!req) break;
        await api(...req); cartState = await api(R.cart + '.js'); changed = true;
      }
    } catch (e) { /* shaker indisponible ou erreur réseau : on n'insiste pas */ }
    finally { giftBusy = false; }
    // Page /cart (rendue côté serveur) : recharger une fois pour montrer le sac corrigé ; l'état suivant est stable
    if (changed && $('[data-v2-cartpage]')) location.reload();
    return changed;
  }
  async function cartGet() { cartState = await api(R.cart + '.js'); await giftSync(); drawCart(); return cartState; }
  async function cartAdd(id, quantity = 1, plan) { await api(R.add + '.js', {items: [{id: +id, quantity, ...(plan ? {selling_plan: +plan} : {})}]}); await cartGet(); openCart(); }
  async function cartChange(key, quantity) { cartState = await api(R.change + '.js', {id: key, quantity}); await giftSync(); drawCart(); }
  function drawCart() {
    const c = cartState; if (!c) return;
    $$('[data-v2-count]').forEach(el => { const was = el.textContent; el.textContent = c.item_count; el.dataset.n = c.item_count; if (was !== String(c.item_count)) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); } });
    if (!cartEl) return;
    const list = $('[data-v2-cart-list]', cartEl), foot = $('[data-v2-cart-foot]', cartEl), ship = $('[data-v2-cart-ship]', cartEl);
    const subbed = c.items.some(it => it.selling_plan_allocation);
    if (!c.item_count) {
      list.innerHTML = `<div class="v2-empty"><b>Your bag is light.</b><p>${esc(T.bagEmpty)}</p><a class="v2-btn v2-btn--buy" href="${esc(P?.url || R.product)}">${esc(T.seeProduct)}</a></div>`;
      foot.hidden = true; ship.hidden = true; return;
    }
    foot.hidden = false; ship.hidden = false;
    // Livraison : toujours offerte en abonnement ; sinon 4,90 €, offerte sur la 1re commande avec l'email
    ship.innerHTML = `${esc(subbed ? T.shipFreeOk : T.shipAddOne)}<i style="--k:${subbed ? 1 : 0}"></i>`;
    const solo = variants[0], duo = variants[1];
    // Bump Solo vers Duo (21/10 soir) : un Solo en achat unique, quantité 1, sans Duo ni Trio dans le sac ; le Duo remplace le Solo
    const soloOnce = c.items.find(it => isPack(it, 0) && !it.selling_plan_allocation && it.quantity === 1);
    const showUp = soloOnce && !c.items.some(it => isPack(it, 1) || isPack(it, 2)) && duo && duo.available !== false;
    const plus = d => d % 100 ? cents(d) : eur(d / 100).replace(/[.,]00(?=\D|$)/, '');
    list.innerHTML = c.items.map(it => isGift(it) ? `<div class="v2-line v2-line--gift">
        <img src="${esc(it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=200' : V.packImg)}" alt="" width="72" height="72" loading="lazy">
        <div><b>${esc(T.giftLine)}</b><small>${esc(it.product_title)}</small></div>
        <div class="pr">${cents(it.final_line_price)}${it.original_line_price > it.final_line_price ? `<s>${cents(it.original_line_price)}</s>` : ''}</div>
      </div>` : `<div class="v2-line">
        <img src="${esc(it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=200' : V.packImg)}" alt="" width="72" height="72" loading="lazy">
        <div><b>${esc(it.product_title)}</b><small>${esc(it.variant_title || '')}</small>
          <div class="v2-qty"><button type="button" data-q="${esc(it.key)}" data-n="${it.quantity - 1}" aria-label="${esc(T.less)}">−</button><span>${it.quantity}</span><button type="button" data-q="${esc(it.key)}" data-n="${it.quantity + 1}" aria-label="${esc(T.more)}">+</button></div></div>
        <div class="pr">${cents(it.final_line_price)}${it.original_line_price > it.final_line_price ? `<s>${cents(it.original_line_price)}</s>` : ''}<button type="button" class="rm" data-q="${esc(it.key)}" data-n="0">${esc(T.remove)}</button></div>
      </div>`).join('') + (showUp ? `<div class="v2-up"><b>${esc(fill(T.upTitle, {d: plus(duo.price - solo.price)}))}</b><p>${esc(fill(T.upText, {duo: cents(duo.price), was: cents(solo.price * 2)}))}</p><button type="button" class="v2-btn v2-btn--white v2-btn--full" data-v2-upgrade="${duo.id}" data-from="${esc(soloOnce.key)}">${esc(T.upBtn)}</button></div>` : '');
    $('[data-v2-cart-total]', cartEl).textContent = cents(c.total_price);
  }
  function openCart() { if (!cartEl) return; closePick(); closePop(); cartEl.classList.add('is-open'); cartEl.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; bbarCheck(); setTimeout(() => $('[data-v2-cart-close]', cartEl)?.focus(), 300); }
  function closeCart() { if (!cartEl?.classList.contains('is-open')) return; cartEl.classList.remove('is-open'); cartEl.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; bbarCheck(); }
  if (cartEl) {
    $$('[data-v2-cart-close]', cartEl).forEach(b => b.addEventListener('click', closeCart));
    cartEl.addEventListener('click', async e => {
      const q = e.target.closest('[data-q]');
      if (q) { q.disabled = true; try { await cartChange(q.dataset.q, Math.max(0, +q.dataset.n)); } catch { toast(T.cartErr); } return; }
      const up = e.target.closest('[data-v2-upgrade]');
      if (up) { up.classList.add('is-busy'); try { await api(R.add + '.js', {items: [{id: +up.dataset.v2Upgrade, quantity: 1}]}); await cartChange(up.dataset.from, 0); } catch { toast(T.cartErr); cartGet().catch(() => {}); } }
    });
  }
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-v2-open-cart]');
    if (o && cartEl) { e.preventDefault(); openCart(); cartGet().catch(() => {}); }
  });
  /* Ajouter au sac */
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-add-to-cart]'); if (!b) return;
    e.preventDefault();
    const id = b.dataset.variant;
    if (!id) { location.href = P?.url || R.product; return; }
    b.classList.add('is-busy');
    const lbl = $('.lbl', b), old = lbl?.textContent;
    try { await cartAdd(id, 1, b.dataset.plan); if (lbl) { lbl.textContent = T.added; setTimeout(() => { lbl.textContent = old; }, 1800); } }
    catch (err) { toast(esc(err?.description || err?.message || T.cartErr)); }
    finally { b.classList.remove('is-busy'); }
  });
  /* Le comparateur ramène vers le panneau d'achat (fiche) ou l'offre (accueil) */
  if (!$('#buy-rok') && $('[data-v2-offer]')) $('[data-v2-offer]').id ||= 'offer';
  if (body.dataset.waitlist !== 'true') cartGet().catch(() => {});

  /* ---------- Galerie de la fiche ---------- */
  $$('[data-v2-gal]').forEach(g => {
    const track = $('.v2-gal__track', g), dots = $$('.v2-gal__dots i', g);
    if (!track || !dots.length) return;
    track.addEventListener('scroll', () => { const i = Math.round(track.scrollLeft / track.clientWidth); dots.forEach((d, k) => d.classList.toggle('is-on', k === i)); }, {passive: true});
  });

  /* ---------- Pop-up email : jamais à l'arrivée, jamais avec le sélecteur ---------- */
  const pop = $('[data-v2-pop]');
  function openPop() {
    if (!pop || pickOpen || $('.v2-cart.is-open') || $('[data-rc-modal][open]') || $('.v2-menu.is-open')) return false;
    pop.classList.add('is-open'); pop.setAttribute('aria-hidden', 'false'); store.set(K.pop, String(Date.now())); return true;
  }
  function closePop() { if (!pop) return; pop.classList.remove('is-open'); pop.setAttribute('aria-hidden', 'true'); }
  if (pop) {
    /* 11/10 : à chaque ouverture (bouton, minuterie, sortie…), phrase personnalisée avec le pré choisi */
    const fillPre = () => {
      const pre = $('[data-pop-pre]', pop); if (!pre) return;
      const ok = chosen && !store.get(K.nopre) && !cur.hidden; pre.hidden = !ok;
      if (ok) pre.textContent = pre.dataset.tpl.replace('{name}', cur.name).replace('{r}', num(grams(cur.doses), grams(cur.doses) < 10 ? 2 : 1)).replace('{k}', num(grams(ROKD), 1));
    };
    let wasOpen = false;
    new MutationObserver(() => { const o = pop.classList.contains('is-open'); if (o && !wasOpen) fillPre(); wasOpen = o; }).observe(pop, {attributes: true, attributeFilter: ['class']});
    $$('[data-v2-pop-close]', pop).forEach(b => b.addEventListener('click', closePop));
    /* 11/10 : inscription notée seulement au retour confirmé (rok-waitlist) */
    const last = +(store.get(K.pop) || 0), recent = Date.now() - last < 21 * 864e5;
    // Aperçu à la demande : ?pop=1 l'ouvre tout de suite (contrôle par Enzo, navigation privée comprise)
    if (/[?&]pop=1/.test(location.search)) setTimeout(() => { if (pickOpen) closePick(); openPop(); }, 600);
    else if (!recent && !store.get(K.sub) && !/customer_posted=true/.test(location.search)) {
      /* 12/10 (Enzo) : deux déclenchements seulement. Fiche produit : dès l'arrivée (1,5 s). Accueil : en bas de page (85 %).
         Plus de minuterie ni de sortie de page ; jamais par-dessus le pop-up pré, ni moins de 5 s après sa fermeture. */
      const isPdp = body.classList.contains('tpl-page-product'), isHome = body.classList.contains('tpl-index');
      if (isPdp || isHome) {
        const t0 = Date.now(); let armed = true;
        const depth = () => (scrollY + innerHeight) / document.documentElement.scrollHeight;
        const ready = () => armed && !pickOpen && Date.now() - pickClosedAt > 5000;
        const fire = () => { if (ready() && openPop()) { armed = false; clearInterval(iv); } };
        const iv = setInterval(() => { if ((isPdp && Date.now() - t0 > 1500) || (isHome && depth() > .85)) fire(); }, 500);
      }
    }
  }
  

  /* Lignes ajustées à la largeur (signature du pied de page) */
  const fitEls = $$('[data-v2-fit]');
  const fitAll = () => fitEls.forEach(el => { el.style.fontSize = ''; const w = el.parentElement.clientWidth, sw = el.scrollWidth, fs = parseFloat(getComputedStyle(el).fontSize); if (sw > 0) el.style.fontSize = Math.floor(fs * w / sw * .995) + 'px'; });
  if (fitEls.length) { fitAll(); document.fonts?.ready.then(fitAll); addEventListener('resize', fitAll); }

  setTimeout(() => { if (!pickOpen && scrollY < innerHeight) showHint(); }, 7000);
  onScroll();
})();
